__turbopack_context__.v({
  "buyNow": "CaRetailAvailabilityModal-module__UIDDsG__buyNow",
  "close": "CaRetailAvailabilityModal-module__UIDDsG__close",
  "description": "CaRetailAvailabilityModal-module__UIDDsG__description",
  "dialog": "CaRetailAvailabilityModal-module__UIDDsG__dialog",
  "finePrint": "CaRetailAvailabilityModal-module__UIDDsG__finePrint",
  "header": "CaRetailAvailabilityModal-module__UIDDsG__header",
  "overlay": "CaRetailAvailabilityModal-module__UIDDsG__overlay",
  "retailerLink": "CaRetailAvailabilityModal-module__UIDDsG__retailerLink",
  "retailerLogo": "CaRetailAvailabilityModal-module__UIDDsG__retailerLogo",
  "retailerLogoCostco": "CaRetailAvailabilityModal-module__UIDDsG__retailerLogoCostco",
  "retailers": "CaRetailAvailabilityModal-module__UIDDsG__retailers",
  "title": "CaRetailAvailabilityModal-module__UIDDsG__title",
});
